import { FooterLink } from '@/models/footer-link.ts';

import { dayjs } from '@/utils/dayjs-setup.ts';
import { cn } from '@/utils/style-utils.ts';

interface Props {
    links: FooterLink[];
    className?: string;
}

export const Footer = ({ links, className }: Props) => {
    const currentYear = dayjs().year();
    const copyrightText = `© ${currentYear} Eterno`;

    return (
        <footer className={cn('mt-auto w-full border-t border-border bg-background', className)}>
            <div className="mx-auto flex max-w-350 flex-wrap items-center justify-between gap-4 px-6 py-4">
                <div className="text-xs text-muted-foreground">{copyrightText}</div>
                {links.length > 0 && (
                    <div className="flex gap-4">
                        {links.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                className="text-xs text-muted-foreground transition-colors hover:text-foreground"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </footer>
    );
};
